import React, { useEffect, useState, useRef } from "react";
import QRCode from "qrcode.react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { toastError, toastSuccess } from "../../Common/ToastAlert";
// import CopyIcon from "../../../assets/images/copy.svg";
import TrustGridLogo from "../../../assets/images/trustgrid-ncc-logo-center.svg";
import * as htmlToImage from "html-to-image";
const ConsortiumQrModal = (props) => {
  const [QRdata, setQRdata] = useState({ networkId: "", networkName: "" });
  const downloadCardRef = useRef(null);
  useEffect(() => {
    if (props?.data) {
      setQRdata({
        networkId: props.data.id || "",
        networkName: props.data.value || "",
      });
    }
  }, [props?.data]);

  const handleDownload = async () => {
    if (downloadCardRef.current === null) return;

    try {
      // Capture the entire blue card as a PNG
      const dataUrl = await htmlToImage.toPng(downloadCardRef.current, {
        cacheBust: true,
        backgroundColor: "#323448", // Ensures the background stays blue in the export
      });

      const link = document.createElement("a");
      link.download = `consortium-qr-${props?.data?.name || "download"}.png`;
      link.href = dataUrl;
      link.click();

      toast.success("Image downloaded successfully", toastSuccess());
    } catch (err) {
      console.error("Oops, something went wrong!", err);
      toast.error("Failed to download image", toastError());
    }
  };

  const handleCopy = (id) => {
    navigator.clipboard.writeText(id).then(
      (id) => {
        toast.success("QR Code copied successfully", toastSuccess());
      },
      (err) => {
        toast.error("Oops! Try Again Later." + err, toastError());
      },
    );
  };
  const QRdataString = JSON.stringify(QRdata);
  const qrCodeString = btoa(QRdataString);

  const displayName = props?.data?.name || props?.data?.label || "-";
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="dsm-modal-popup"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Consortium QR Code
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">
        <div className="d-flex align-items-center flex-column justify-content-center">
          <p>
            This QR has to be displayed on the external facing website for
            Client Organization.
          </p>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div
            className="d-flex flex-column align-items-center justify-content-center rounded-3 p-4 text-center shadow"
            // id="downloadCard"
            ref={downloadCardRef}
            style={{
              width: "80%",
              height: "auto",
              background: "#323448ff",
            }}
          >
            <h3
              className="text-white mb-2 w-100 text-break"
              style={{ fontSize: "1.75rem" }}
            >
              {displayName}
            </h3>
            <div
              className="d-flex align-items-center justify-content-center mb-4 p-2"
              style={{
                border: "2px solid #4A4D63",
                borderRadius: "12px",
              }}
            >
              <QRCode
                value={QRdataString}
                size={200}
                id="qrCode"
                fgColor={"#fff"}
                bgColor={"#4398cd18"}
                includeMargin={true}
              />
            </div>
            <div className="rounded-2 p-2" style={{ background: "#323448b9" }}>
              <img
                src={TrustGridLogo}
                alt="verifier-logo"
                className="img-fluid"
                style={{
                  height: "50px",
                  width: "200px",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div className="w-60 mt-3 qr-code-button-group ">
            <button
              type="button"
              className="dsm-btn-primary w-100 mb-2 gap-2 d-flex"
              onClick={handleDownload}
            >
              <i className="bi bi-download"></i>
              <span>Download QR</span>
            </button>
            {/* <button
              type="button"
              className="dsm-btn-secondary w-100"
              onClick={() => handleCopy(qrCodeString)}
            >
              <img className="img-fluid copy-icon" src={CopyIcon} alt="copy" />
              Copy QR
            </button> */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConsortiumQrModal;
